export const iksTips: string[] = [
  'Daily: Use filters to narrow down your data — no need to scroll endlessly.',
  'Daily: Keep your browser up to date for best performance.',
  'Daily: Refresh the browser if something appears stuck.',
  'Leads: Use “Hot Leads” filters to focus on those ready to enroll.',
  'Contacts: Verify contact emails and phones before bulk messaging.',
  'Contacts: Archive inactive contacts to declutter.',
  'Contacts: Keep your contact info updated to avoid failed deliveries.',
  'Automation: Test automations on sample data before going live.',
  'Automation: Disable old workflows to prevent duplication.',
  'Scheduling: Sync your schedule with Google Calendar for convenience.',
  'Tasks: Color-code task types for easy visual reference.',
  'Reports: Export reports as Excel or PDF for sharing.',
  'Reports: Save your own configurations as custom reports.',
  'Security: Create user roles with the right permissions.',
  'Security: Change your password regularly for better protection.',
  'Security: Use strong passwords that differ from personal ones.',
  'Security: Log out from shared devices after work.',
  'Security: Use trusted networks when accessing sensitive data.',
  'Help: Visit the Help Center for detailed guides anytime.',
  'Help: Explore step-by-step videos in the Help Center.',
  'Help: Follow IntelliKid Systems on LinkedIn for news.',
  'Help: Leave feedback to help improve IntelliKid Systems.',
  'Have a productive day — with IKS your data just got a little smarter!',
]
